// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';

// Section for type definition -----------------------------------------------------------------------------------------
type CustomTabsProps = {
  tabValue: number;
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
};

export default function CustomTabs({ tabValue, handleChange }: CustomTabsProps): JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  return (
    <Box
      sx={{
        width: isMobile ? '100%' : undefined,
        borderBottom: 2,
        borderColor: '#00375F',
        backgroundColor: isMobile ? '#F7F7F7' : undefined,
        borderRadius: '2px',
      }}
    >
      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label="basic tabs example"
        TabIndicatorProps={{ style: { display: 'none' } }}
        centered={isMobile}
        sx={{
          '.Mui-selected': { backgroundColor: '#00375F' },
          marginLeft: isMobile ? undefined : '32px',
          minHeight: '50px',
          '@media (max-width:767px)': {
            '& .MuiTabs-flexContainer': {
              display: 'flex',
              justifyContent: 'space-between',
              gap: '8px',
            },
          },
        }}
        className="max-md:px-5 w-full"
      >
        <Tab
          label="1年間"
          id="tab-0"
          aria-controls="tabPanel-0"
          className="max-md:mr-0 w-[164px] max-md:w-[31%] text-sm text-white font-bold whitespace-nowrap"
          sx={{
            minWidth: '87px',
            backgroundColor: '#B4B4B4',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            marginRight: '8px',
            padding: tabValue === 0 ? '12px 30px' : '12px 30px 17px',
            minHeight: '40px',
            height: '46px',
            top: tabValue === 0 ? '4px' : '10px',
          }}
        />
        <Tab
          label="3年間"
          id="tab-1"
          aria-controls="tabPanel-1"
          className="max-md:mr-0 w-[164px] max-md:w-[31%] text-sm text-white font-bold whitespace-nowrap"
          sx={{
            minWidth: '87px',
            backgroundColor: '#B4B4B4',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            marginRight: '8px',
            padding: tabValue === 1 ? '12px 30px' : '12px 30px 17px',
            minHeight: '40px',
            height: '46px',
            top: tabValue === 1 ? '4px' : '10px',
          }}
        />
        <Tab
          label="5年間"
          id="tab-2"
          aria-controls="tabPanel-2"
          className="max-md:mr-0  w-[164px] max-md:w-[31%] text-sm text-white font-bold whitespace-nowrap"
          sx={{
            minWidth: '87px',
            backgroundColor: '#B4B4B4',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            marginRight: '8px',
            padding: tabValue === 2 ? '12px 30px' : '12px 30px 17px',
            minHeight: '40px',
            height: '46px',
            top: tabValue === 2 ? '4px' : '10px',
          }}
        />
      </Tabs>
    </Box>
  );
}
